import { Controller } from "@hotwired/stimulus"

// Keeps a submit button disabled until its source field has content. Used on
// "Regenerar con estas notas": an empty submit would spend a paid generation
// without asking for anything different.
export default class extends Controller {
  static targets = ["source", "submit"]

  connect() {
    this.refresh()
  }

  refresh() {
    const filled = this.hasSourceTarget && this.sourceTarget.value.trim().length > 0
    this.submitTargets.forEach((button) => { button.disabled = !filled })
  }
}
